import { useState, useEffect, useCallback } from 'react';
import { isApiError } from '@aiptyg/types';
import * as tasksService from '../services/tasks.service';
import type { TaskDTO } from '../types/tasks.types';

function resolveError(e: unknown): string {
  if (isApiError(e)) {
    const map: Record<string, string> = {
      admin_role_required: '无管理员权限',
      task_not_found: '任务不存在',
      task_has_assignments: '任务已有用户领取，可改为归档移除',
      network_error: '网络连接失败，请检查网络',
    };
    return map[e.message] ?? `请求失败 (${e.message})`;
  }
  return '未知错误';
}

export function useTaskDetail(id: number) {
  const [task, setTask] = useState<TaskDTO | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await tasksService.getTask(id);
      setTask(result);
    } catch (e) {
      setError(resolveError(e));
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  const removeTask = useCallback(async (): Promise<string | null> => {
    try {
      await tasksService.deleteTask(id);
      return null;
    } catch (e) {
      return resolveError(e);
    }
  }, [id]);

  return { task, loading, error, reload: load, removeTask };
}
